const Mn = require('backbone.marionette');
const template = require('../templates/partials/component-product-pool-media/grid.hbs');
const ProductPoolMediaView = require('./ProductPoolMedia');

const View = Mn.CompositeView.extend({
  initialize: ProductPoolMediaView.prototype.initialize,
  template,
  childViewContainer: '.product-pool-media-grid',
});

module.exports = View;
